'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FT_IB_CARD_MANAGEMENT, FT_IB_COMPANY_MANAGEMENT, FT_IB_USER_MANAGEMENT } from '@whitbread-eos/api';
import { getPathForLocale, useFeatureToggle } from '@whitbread-eos/utils';
import { getLocaleByPathname, useTranslation } from '@whitbread-eos/utils/server';
import { usePathname } from 'next/navigation';
import SidebarLink from '../SidebarLink/SidebarLink.component';
const SecondLevelNav = ({ isTravelManager, isAccountHolder, onLinkClick })=>{
    const baseDataTestId = 'SecondLevelNav';
    const pathname = usePathname();
    const locale = getLocaleByPathname(pathname);
    const { t } = useTranslation();
    const { [FT_IB_USER_MANAGEMENT]: isUserManagementActive, [FT_IB_COMPANY_MANAGEMENT]: isCompanyManagementActive, [FT_IB_CARD_MANAGEMENT]: isCardManagementActive } = useFeatureToggle();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": `${baseDataTestId}-container`,
        className: secondLevelNavStyle,
        children: [
            isUserManagementActive && (isAccountHolder || isTravelManager) && /*#__PURE__*/ _jsx(SidebarLink, {
                label: t('layout.menu.manage.options.employees'),
                isActive: pathname.includes('employees'),
                href: getPathForLocale(locale, 'manage/employees'),
                testId: "ManageEmployees",
                onClick: ()=>onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick()
            }),
            isCompanyManagementActive && isTravelManager && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SidebarLink, {
                        label: t('layout.menu.manage.options.allowances'),
                        isActive: pathname.includes('allowances'),
                        href: getPathForLocale(locale, 'manage/allowances'),
                        testId: "BookingAllowances",
                        onClick: ()=>onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick()
                    }),
                    /*#__PURE__*/ _jsx(SidebarLink, {
                        label: t('layout.menu.manage.options.alerts'),
                        isActive: pathname.includes('alerts'),
                        href: getPathForLocale(locale, 'manage/alerts'),
                        testId: "BookingAlerts",
                        onClick: ()=>onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick()
                    })
                ]
            }),
            isCardManagementActive && /*#__PURE__*/ _jsx(SidebarLink, {
                label: t('layout.menu.manage.options.cards'),
                isActive: pathname.includes('cards'),
                href: getPathForLocale(locale, 'manage/cards'),
                testId: "CardManagement",
                onClick: ()=>onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick()
            }),
            isCompanyManagementActive && isTravelManager && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SidebarLink, {
                        label: t('layout.menu.manage.options.questions'),
                        isActive: pathname.includes('questions'),
                        href: getPathForLocale(locale, 'manage/questions'),
                        testId: "EmployeeQuestions",
                        onClick: ()=>onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick()
                    }),
                    /*#__PURE__*/ _jsx(SidebarLink, {
                        label: t('layout.menu.manage.options.company'),
                        isActive: pathname.includes('company'),
                        href: getPathForLocale(locale, 'manage/company'),
                        testId: "CompanyDetails",
                        onClick: ()=>onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick()
                    })
                ]
            })
        ]
    });
};
export default SecondLevelNav;
const secondLevelNavStyle = 'flex flex-col gap-2';
